import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { Table } from "../../components";
import { useEffect, useMemo, useState } from "react";
import { userFriendlyDateTimestamp } from "../../utils/timestamps";
import { IUser } from "../../utils/types";
import { useGetUserLoginHistoryQuery } from "../../api/apiSlice";

interface Props {
  user: IUser;
  handleClose: () => void;
}

export const ViewUserLoginHistory: React.FC<Props> = props => {
  const { user, handleClose } = props;

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [globalFilter, setGlobalFilter] = useState<string>("");

  // Reset to first page whenever the search term changes
  useEffect(() => {
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
  }, [globalFilter]);

  const { data, isLoading, isFetching } = useGetUserLoginHistoryQuery({
    id: user.id,
    per_page: pagination.pageSize,
    page: pagination.pageIndex + 1,
    q: globalFilter || undefined,
  });

  const columns = useMemo(() => {
    return [
      { accessorKey: "device", header: "Device", enableColumnFilter: false },
      { accessorKey: "ip", header: "IP Address", size: 200, enableColumnFilter: false },
      {
        accessorKey: "city",
        header: "City",
        enableColumnFilter: false,
      },
      {
        accessorKey: "country",
        header: "Country",
        enableColumnFilter: false,
      },
      {
        accessorKey: "mobileAppVersion",
        header: "App Version",
        enableColumnFilter: false,
        Cell: ({ row }: any) => row.original.mobileAppVersion || "-",
      },
      {
        accessorKey: "platform",
        header: "Platform",
        enableColumnFilter: false,
        Cell: ({ row }: any) => row.original.platform || "-",
      },
      {
        accessorKey: "createdAt",
        header: "Recent Activity",
        size: 300,
        enableColumnFilter: false,
        Cell: ({ row }: any) => userFriendlyDateTimestamp(row.original.createdAt),
      },
    ];
  }, []);

  return (
    <Box>
      <DialogTitle>
        <Typography variant="h6">Login History</Typography>
      </DialogTitle>
      <DialogContent>
        <Table
          enableStickyHeader
          columns={columns}
          data={data?.data || []}
          manualPagination
          manualFiltering
          onPaginationChange={setPagination}
          onGlobalFilterChange={setGlobalFilter}
          state={{ pagination, globalFilter }}
          rowCount={data?.total}
          loading={isLoading || isFetching}
        />
      </DialogContent>
      <DialogActions>
        <Button disableElevation variant="outlined" sx={{ width: 100, borderRadius: "20px" }} onClick={handleClose} type="button">
          Cancel
        </Button>
      </DialogActions>
    </Box>
  );
};
